import script from "./RedefinirLoginSenhaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RedefinirLoginSenhaModal.vue?vue&type=script&setup=true&lang=js"

import "./RedefinirLoginSenhaModal.vue?vue&type=style&index=0&id=4cadb9d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cadb9d9"]])

export default __exports__